import { Link } from 'react-router-dom';
import { testimonials } from '../../../mocks/sharedData';

export default function Testimonials() {
  return (
    <section className="bg-slate-50 py-24 relative overflow-hidden">
      <div className="absolute top-0 left-0 w-full h-px bg-slate-200" />
      <div className="absolute bottom-0 left-0 w-full h-px bg-slate-200" />

      <div className="max-w-7xl mx-auto px-6">
        {/* Header */}
        <div className="text-center mb-16">
          <span className="inline-block px-4 py-1.5 rounded-full text-orange-700 text-xs font-bold uppercase tracking-[0.2em] border border-orange-200 bg-orange-50 mb-4">
            Client Success Stories
          </span>
          <h2 className="font-display text-4xl lg:text-5xl font-black text-slate-900 mb-4">
            Trusted by Homeowners &amp; Businesses Nationwide
          </h2>
          <div className="flex items-center justify-center gap-1.5 mb-2">
            {[1, 2, 3, 4, 5].map((star) => (
              <div key={star} className="w-5 h-5 flex items-center justify-center">
                <i className="ri-star-fill text-amber-400 text-lg" />
              </div>
            ))}
            <span className="text-slate-900 text-sm font-bold ml-2">4.9/5</span>
            <span className="text-slate-500 text-sm ml-1">from 200+ verified reviews</span>
          </div>
        </div>

        {/* Testimonial grid */}
        <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-5 mb-14">
          {testimonials.map((t) => (
            <div
              key={t.id}
              className="rounded-2xl p-7 border border-slate-200 bg-white hover:border-orange-200 hover:shadow-sm transition-all duration-300 cursor-default relative overflow-hidden group"
            >
              {/* Quote watermark */}
              <div className="absolute top-3 right-4 text-8xl text-slate-100 font-display font-black leading-none select-none group-hover:text-orange-50 transition-colors">
                &ldquo;
              </div>

              {/* Stars */}
              <div className="flex items-center gap-0.5 mb-5">
                {[1, 2, 3, 4, 5].map((star) => (
                  <div key={star} className="w-4 h-4 flex items-center justify-center">
                    <i className="ri-star-fill text-amber-400 text-sm" />
                  </div>
                ))}
              </div>

              {/* Quote */}
              <p className="text-slate-600 text-sm leading-relaxed mb-6 italic">&ldquo;{t.quote}&rdquo;</p>

              {/* Author */}
              <div className="flex items-center gap-3 pt-4 border-t border-slate-100">
                <div className="w-11 h-11 rounded-full bg-gradient-to-br from-orange-400 to-orange-600 flex items-center justify-center flex-shrink-0">
                  <span className="text-white font-black text-sm">{t.name.charAt(0)}</span>
                </div>
                <div className="flex-1 min-w-0">
                  <p className="text-slate-900 font-bold text-sm truncate">{t.name}</p>
                  <p className="text-slate-400 text-xs truncate">{t.title} · {t.company}</p>
                </div>
                <span className="px-2 py-1 rounded-full bg-orange-50 border border-orange-200 text-orange-700 text-xs font-semibold flex-shrink-0">
                  {t.industry}
                </span>
              </div>
            </div>
          ))}
        </div>

        {/* Post-testimonial CTA banner */}
        <div className="rounded-2xl border border-slate-200 bg-white p-8 flex flex-col md:flex-row items-center justify-between gap-6">
          <div className="text-center md:text-left">
            <p className="text-slate-900 font-display font-black text-xl mb-1">
              Join 500+ properties protected by Secure2Ware
            </p>
            <p className="text-slate-500 text-sm">
              See why homeowners and businesses across the US trust us for security installation.
            </p>
          </div>
          <div className="flex flex-wrap gap-3 flex-shrink-0">
            <Link
              to="#contact"
              className="inline-flex items-center gap-2 px-7 py-3.5 rounded-xl bg-slate-900 text-white font-black text-sm hover:bg-slate-800 transition-all duration-200 whitespace-nowrap cursor-pointer"
            >
              Get Free Quote
              <i className="ri-arrow-right-line" />
            </Link>
            <a
              href="tel:+18005551234"
              className="inline-flex items-center gap-2 px-7 py-3.5 rounded-xl border-2 border-slate-200 text-slate-700 font-semibold text-sm hover:border-orange-300 hover:text-orange-600 transition-all duration-200 whitespace-nowrap cursor-pointer"
            >
              <i className="ri-phone-fill text-orange-500" />
              (800) 555-1234
            </a>
          </div>
        </div>
      </div>
    </section>
  );
}
